import { Injectable, Inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';


@Injectable({
    providedIn: 'root',
  })
  export class HeaderService {
    private _isDashboard: boolean = true;
    subject = new Subject();

    updateHeader(change: boolean) {
        this._isDashboard = change;
        this.subject.next(this._isDashboard);
    }

    clear(){
        this._isDashboard = true;
        this.subject.next(this._isDashboard);
    }
  
  }